import { createFileRoute } from "@tanstack/react-router";
import { PublicReportPage } from "@/features/reportshare/PublicReportPage";

/** A shared report, read only, at /r/<token>. Sits outside the app shell: no sign-in is needed. */
export const Route = createFileRoute("/r/$token")({
  component: function SharedReportRoute() {
    const { token } = Route.useParams();
    return <PublicReportPage token={token} />;
  },
});
